import mergeVariables from '../../../fe-brary-internals/merge-variables';
var neutrals = () => ({
  colour: {
    white: '#fff',
    black: '#000',
    neutral50: '#fafbfc',
    neutral100: '#f2f5f7',
    neutral200: '#e6e9ed',
    neutral300: '#d0d3d9',
    neutral400: '#a9afba',
    neutral500: '#7e8594',
    neutral600: '#515b6e',
    neutral700: '#3c475b',
    neutral800: '#1e293d',
    neutral900: '#000'
  }
});
var neutralTexts = context => ({
  colour: {
    neutral50Text: context.colour.neutral700,
    neutral100Text: context.colour.neutral700,
    neutral200Text: context.colour.neutral700,
    neutral300Text: context.colour.neutral700,
    neutral400Text: context.colour.neutral700,
    neutral500Text: context.colour.white,
    neutral600Text: context.colour.white,
    neutral700Text: context.colour.white,
    neutral800Text: context.colour.white,
    neutral900Text: context.colour.white
  }
});
var palette = context => ({
  colour: {
    primaryLight: context.colour.creSlate400,
    primary: context.colour.creSlate500,
    primaryDark: context.colour.creSlate600,
    primaryLightText: context.colour.white,
    primaryText: context.colour.white,
    primaryDarkText: context.colour.white,
    secondaryLight: context.colour.creSriracha400,
    secondary: context.colour.creSriracha500,
    secondaryDark: context.colour.creSriracha600,
    secondaryLightText: context.colour.white,
    secondaryText: context.colour.white,
    secondaryDarkText: context.colour.white,
    accentLight: '#ffcec3',
    accent: '#ff613d',
    accentDark: '#f74a23',
    accentLightText: context.colour.neutral800,
    accentText: context.colour.white,
    accentDarkText: context.colour.white
  }
});
var namedColours = context => ({
  colour: {
    brandYellowLight: context.colour.creYellow100,
    brandYellow: context.colour.creYellow500,
    brandYellowDark: '#ffa200',
    brandOrangeLight: '#ffcec3',
    brandOrange: '#ff613d',
    brandOrangeDark: '#f74a23',
    brandGreenLight: context.colour.creGreen100,
    brandGreen: context.colour.creGreen400,
    brandGreenDark: '#0c9700',
    brandAquaLight: context.colour.creAqua100,
    brandAqua: context.colour.creAqua400,
    brandNavyLight: context.colour.creNavy100,
    brandNavy: context.colour.creNavy400,
    brandPurpleLight: context.colour.crePurple100,
    brandPurple: context.colour.crePurple400,
    brandBlue: '#514aea'
  }
});
export default (context => mergeVariables(neutrals, neutralTexts, palette, namedColours)(context));